<template>
  <v-container class="inner-main pt-2 mb-10">
    <v-row justify="start">
      <v-col>
        <h1 class="text-secondary">{{ shop?.name }}</h1>
        <h6>{{ shop?.tagline }}</h6>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <v-responsive :aspect-ratio="1 / 1">
          <v-sheet :style="shopAvatar" color="primary w-100 h-100">
          </v-sheet>
        </v-responsive>

        <v-card color="default" class="mt-3 contact-card" elevation="0">
          <v-card-title>
            <h4>
              {{ $t('shop.wizard.steps.openingTimes.title') }}
            </h4>
          </v-card-title>

          <v-card-text>

            <div v-for="entry in shop?.businessHours" :key="entry.id">
              <span class="mr-3 dayDesc">
                {{ getShortDay(entry.fromDay, selectedLanguage.toUpperCase()) }} bis
                {{ getShortDay(entry.toDay, selectedLanguage.toUpperCase()) }}
              </span>
              <!-- <span> -->
              <!-- {{ entry.from.hour }}:{{ entry.from.minute == 0 ? '00' : entry.from.minute }} - {{ entry.to.hour }}:{{
                entry.to.minute == 0 ? '00' : entry.to.minute }} -->
                {{ entry.from.slice(0,5) }} - {{ entry.to.slice(0,5) }}
              <!-- </span><br> -->
            </div>
            <!-- [Auf Anfrage] -->
          </v-card-text>
        </v-card>

        <v-btn v-if="shop != null && [typeof shop.onlineShopUrl] != 'undefined'" variant="flat" target="_blank"
          :href="shop?.onlineShopUrl" size="large" color="primary"
          class="white--text my-2 w-100">{{ $t('shop.profile.onlineshop') }}</v-btn>

        <v-card color="default" class="mt-3" elevation="0">
          <v-card-title>
            <h4>
              {{ $t('main.footer.contact') }}
            </h4>
          </v-card-title>

          <v-card-text class="text-center">
            <div class="text-left">
              <span v-if="shop?.street != '' && [typeof shop?.street] != 'undefined'">
                {{ shop?.street }}
                <br>
              </span>
              <span v-if="shop?.postcode != '' && shop?.city != ''">
                {{ shop?.postcode }} {{ shop?.city }}<br>
              </span>
              <span v-if="shop?.district != '' && [typeof shop?.district] != 'undefined'">
                {{ shop?.district }}<br>
              </span>
              <br>
            </div>

            <div class="text-left mb-2">
              <v-icon size="x-small" class="me-2" v-if="[typeof shop?.email] != 'undefined'">mdi-mail</v-icon>
              <a class="mr-1" style="font-size:14px" target="_blank" :href="`mailto:${shop?.email}`"
                v-if="typeof shop?.email != 'undefined'">{{ $t('shop.profile.contact.email') }}</a><br>

              <v-icon size="x-small" class="me-2"
                v-if="typeof shop?.phoneNumber != 'undefined' && shop?.phoneNumber != ''">mdi-phone</v-icon>
              <a style="font-size:14px" v-if="typeof shop?.phoneNumber != 'undefined' && shop?.phoneNumber != ''"
                :href="`tel:${shop?.phoneNumber}`">
                {{ shop?.phoneNumber }}
              </a>
              <br v-if="[typeof shop?.phoneNumber] != 'undefined' && shop?.phoneNumber != ''">

              <v-icon size="x-small" class="me-2"
                v-if="typeof shop?.homepage != 'undefined' && shop?.homepage != ''">mdi-earth</v-icon>
              <a style="font-size:14px" target="_blank" :href="shop?.homepage"
                v-if="typeof shop?.homepage != 'undefined' && shop?.homepage != ''">{{ $t('shop.profile.contact.website') }}</a>
            </div>

            <div class="text-left">
              <v-icon size="x-small" class="me-2"
                v-if="[typeof shop?.facebookUrl] != 'undefined' && shop?.facebookUrl != ''">mdi-facebook</v-icon>
              <a class="mr-1" style="font-size:14px" target="_blank" :href="shop?.facebookUrl"
                v-if="typeof shop?.facebookUrl != 'undefined' && shop?.facebookUrl != ''">{{ $t('shop.profile.contact.facebook') }}</a><br
                v-if="typeof shop?.facebookUrl != 'undefined' && shop?.facebookUrl != ''">

              <v-icon size="x-small" class="me-2"
                v-if="typeof shop?.instagramUrl != 'undefined' && shop?.instagramUrl != ''">mdi-instagram</v-icon>
              <a style="font-size:14px" target="_blank" :href="shop?.instagramUrl"
                v-if="typeof shop?.instagramUrl != 'undefined' && shop?.instagramUrl != ''">{{ $t('shop.profile.contact.instagram') }}</a>
            </div>

            <v-btn variant="flat" prepend-icon="mdi-map-marker" color="primary" class="text-white mx-auto mt-3"
              @click="$router.push(`/${selectedArea.urlName}/suche/laden/${shop.urlname}/`)">
              {{ $t('shop.profile.contact.location') }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="9">
        <CustomSlider :autoplay="4000" :showPagination="true" :wrapAround="true" :imageType="'normal'" :count="1"
          :slides="shop?.gallerieAssets" :imageDescription="false" :paginationInner="true">

        </CustomSlider>
        <v-container class="w-100 d-flex justify-content-center py-0" style="margin-top:-25px">
          <v-btn rounded="xl" size="large" class="" color="primary" :elevation="0" variant="flat"
            prepend-icon="mdi-plus-circle-outline" style="border: solid 3px white;"
            @click="() => triggerOpenDownloadAppHint()">
            {{ $t('shop.profile.follow') }}</v-btn>
        </v-container>
        <v-row class="mx-0" align="center" justify="between" v-if="shop?.premiumFeatures">
          <v-col>
            <template v-if="shop?.premiumFeatures.some(feat => feat.name == 'online-shop')">
              <CustomIcon :size="30" :type="'none'" :iconName="`icononlineShop`" :fileType="'png'"></CustomIcon>
              Online-Shop
            </template>
          </v-col>
          <v-col align-self="end" class="text-right">
            <!-- TODO TOOLTIP -->
            <template v-if="shop?.premiumFeatures.some(feat => feat.name == 'voucher')">
              <a href="https://findeling.de/gutscheine" target="_blank">
                <CustomIcon :size="30" :type="'none'" :iconName="`iconGiftcardShop`" :fileType="'png'"></CustomIcon>
              </a>
              {{$t('shop.profile.voucher.icon-text')}}
            </template>
            <v-icon class="ml-2">mdi-account</v-icon><span
              v-html="$t('shop.profile.followers.nr', { nr: shop?.totalFollowers })"></span>
          </v-col>
        </v-row>
        <v-container>
          <h4>{{$t('shop.profile.page.description')}}</h4>
          <div class="description-wrapper mb-3">
            <span class="description-text" :class="{ 'truncated': !openText }" v-html="shop?.description">
            </span>
            <a v-if="shop?.description.length > 800" @click="toggleText" variant="text" class="text-link">
              {{ openText ? 'Weniger' : 'Mehr' }}
            </a>
          </div>
          <CustomProductLabel v-for="label in shop?.labels" :key="label.id" :label="label" />


        </v-container>


        <!-- <v-card color="default" class="mt-5" elevation="0">
          <v-card-title>
            <h4>
              {{$t('shop.profile.page.sectors')}}
            </h4>
          </v-card-title>

          <v-card-text class="">

            <v-row justify-md="start">
              <template v-for="category in shop?.productCategories" :key="category.id">
                <v-col cols="12" md="5">
                  <CustomIcon class="mx-3" :size="35" :type="'category'" :iconName="`${category.identifier}_black`">
                  </CustomIcon>
                  <span class="mr-5">
                    {{ category.translations[selectedLanguage.toUpperCase()].value }}
                  </span>
                </v-col>
              </template>
            </v-row>
          </v-card-text>
        </v-card> -->

        <v-card color="default" class="mt-3" elevation="0">
          <v-card-title>
            <h4>
              {{$t('shop.profile.productgroup')}}
            </h4>
          </v-card-title>

          <v-card-text>
            <v-hover v-for="group in shop?.productGroups" :key="group.id">
              <template v-slot:default="{ isHovering, props }">
                <v-chip v-bind="props" label color="primary" :variant="isHovering ? 'flat' : 'outlined'"
                  class="mr-1 mb-1 hoverable"
                  @click="$router.push(`/${selectedArea.urlName}/suche/produktgruppe/${group.name}/`)">{{
                    group.translations[selectedLanguage.toUpperCase()]?.value }}</v-chip>
              </template>
            </v-hover>
          </v-card-text>
        </v-card>

        <v-card color="default" class="mt-3" elevation="0">
          <v-card-title>
            <h4>
              {{$t('shop.profile.brands')}}
            </h4>
          </v-card-title>

          <v-card-text class="">
            <v-hover v-for="group in shop?.brands" :key="group.id">
              <template v-slot:default="{ isHovering, props }">
                <v-chip v-bind="props" label color="primary" :variant="isHovering ? 'flat' : 'outlined'"
                  class="mr-1 mb-1 hoverable" @click="$router.push(`/${selectedArea.urlName}/suche/marke/${group.name}/`)">
                  {{ group.name }}</v-chip>
              </template>
            </v-hover>
          </v-card-text>
        </v-card>
        <v-row justify="space-between" align="center" class="my-3">
          <v-col class="align-items-center" align-self="center">
            <h4> {{$t('shop.profile.page.news-from', {shopName: shop?.name})}}</h4>
          </v-col>
        </v-row>

        <v-card color="default" class="mt-3" elevation="0" v-if="oldShopNews.length < 1 && !showOldShopNews">

          <v-card-text class="py-16 px-0 text-center">
            <p class="text-center f-16" v-html="$t('shop.profile.stream.hiddenStream.text', {user:shop?.name})">
            </p>
            <v-btn @click="showOldShopNews = true" variant="text" color="primary" class="">{{$t('shop.profile.stream.hiddenStream.button')}}</v-btn>
          </v-card-text>
        </v-card>
        <MasonryGrid :items="shopNews" v-else-if="shopNews.length > 1" :max-columns="2" :min-columns="1">
          <!-- <template v-slot="{ item }">
              <CustomNewsCard :img="item.image" :item="item" :title="item.headline" :openPostPopup="() => openPost(item)">
              </CustomNewsCard>
          </template> -->
          <template #default="{ item }">
            <!-- <CustomPostCard :item="item" /> -->
            <CustomNewsCard :img="item.image" :item="item" :title="item.headline"
              :openPostPopup="() => triggerPostPopup(item)" :goToPost="() => $router.push()">
            </CustomNewsCard>
          </template>
        </MasonryGrid>
        <v-row justify="center" class="mt-3"
          v-if="oldShopNews.length > 0 && !showOldShopNews || shopNews.length > 0 && showOldShopNews">
          <template v-if="loading">
            <v-progress-circular color="primary" indeterminate></v-progress-circular>{{$t('global.common.loading.more')}}
          </template>
          <template v-else>
            <div>
              {{$t('global.common.loading.endOfStream')}}
            </div>
          </template>
        </v-row>
        <div style="
        position: absolute;
        bottom: 40px;
        left: 50%;
        height: 40px;
        width: 40px;
      " v-intersect="infiniteScrolling"
          v-if="oldShopNews.length > 0 && !showOldShopNews || shopNews.length > 0 && showOldShopNews"></div>
      </v-col>
    </v-row>



    <CustomTopSheetDialog v-model="showSheet" :width="600" :title="'Entdecken nach Vorteile'">
      <!-- Du hast bisher noch keine Nachrichten in deiner Inbox.
      Nach einer Anfrage kannst du hier deine Konversationen einsehen und beantworten. -->
      <v-list lines="one" active-class="">
        <v-list-item v-for="(item, index) in items" :key="index" :ripple="false" class="py-0 dialog-list-item"
          @click="null">
          <v-list-item-title>{{ item }}</v-list-item-title>
          <template v-slot:append>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
        </v-list-item>
      </v-list>
    </CustomTopSheetDialog>
  </v-container>
</template>

<script>
import { ref, inject, computed } from 'vue';
import CustomTopSheetDialog from '../custom/CustomTopSheetDialog.vue';
import CustomerSliderImage from '../custom/CustomSliderImage.vue';
import CustomPostCard from '../custom/CustomPostCard.vue';
import CustomProductLabel from '../custom/CustomProductLabel.vue';
import MasonryGrid from '../custom/MasonryGrid.vue';
import { useRoute } from 'vue-router';
import CustomNewsCard from '../custom/CustomNewsCard.vue';
import CustomSlider from '../custom/CustomSlider.vue';

export default {
  components: {
    CustomTopSheetDialog,
    CustomerSliderImage,
    CustomPostCard,
    CustomProductLabel,
    MasonryGrid,
    CustomNewsCard,
    CustomSlider,
  },
  setup() {
    // const showSheet = ref(false);
    const config = {
      itemsToShow: 3
    }
    const selectedLanguage = localStorage.getItem('selectedLanguage');
    const route = useRoute();
    const selectedArea = inject('selectedArea')
    const shopNews = ref([]);
    const showOldShopNews = ref(false);
    const loading = ref(false);
    const oldShopNews = computed(() => {
      const today = new Date();
      return shopNews.value.filter(news => {
        const publishedDate = new Date(news.publishedAt);
        const differenceInDays = (today - publishedDate) / (1000 * 60 * 60 * 24); // Convert ms to days
        return differenceInDays <= 120; // Check if older than 120 days
      });
    })
    const openText = ref(false);
    const toggleText = () => {
      openText.value = !openText.value; // Toggle the open state
    }
    const openDownloadAppHint = inject('openDownloadAppHint')

    const triggerOpenDownloadAppHint = () => {
      if (openDownloadAppHint) {
        openDownloadAppHint();
      }
    }

    const openPostPopup = inject('openPostPopup');

    const triggerPostPopup = (item) => {
      if (openPostPopup) {
        openPostPopup(item); // Call the provided function with the `item`
      }
    }

    return {
      // showSheet:false,
      config,
      openText,
      toggleText,
      selectedArea,
      route,
      selectedLanguage,
      triggerPostPopup,
      showOldShopNews,
      oldShopNews,
      shopNews,
      loading,
      triggerOpenDownloadAppHint
    };
  },

  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      page: 0,
      totalPages: 0,
      showSheet: false,
      items: [
        "Kundenmagnet",
        "Image Booster",
        "Must-Have",
        "Geheimtipp",
        "Margen-Held",
        "PR-Star",
        "Kundenliebling",
        "Durchstarter",
      ],
      shop: null,

    }
  },

  watch: {
    selectedArea(newVal, oldVal) {
      if (newVal.id != oldVal.id) {
        this.fetchShop();
      }
    },
  },

  computed: {
    shopAvatar() {
      return {
        'background-image': `url(${this.$cloudFrontApi}${this.shop?.avatar}/AVATAR)`,
        'background-size': 'cover',
      }
    }
  },

  mounted() {
    if (this.selectedArea.urlName.toLowerCase() === this.$route.params.city.toLowerCase()) {
      this.fetchShop();
    }
  },
  methods: {
    infiniteScrolling(entries, observer, isIntersecting) {
      if (isIntersecting && this.loading == false) {

        this.loading = true;
        setTimeout(() => {
          var _this = this;
          if (this.page < this.totalPages) {
            this.page++;

            this.$axios.post(`/stream/shop/${this.shop.id}`, {
              page: this.page,
              resultsPerPage: 8,
              sortColumn: "created",
              sortDirection: "DESC",
            })
              .then((response) => {
                if (response.data.data.length > 1) {
                  _this.shopNews = [..._this.shopNews, ...response.data.data]
                  // response.data.data.forEach((item) =>
                  // );
                }
                _this.loading = false;
              }
              )
              .catch()

          }
          _this.loading = false;
        }, 500);
      }
    },
    fetchShopNews() {
      this.$axios.post(`/stream/shop/${this.shop.id}`, {
        page: this.page,
        resultsPerPage: 8,
        sortColumn: "created",
        sortDirection: "DESC",
      })
        .then(this.shopNewsFetched)
        .catch(error => {
          console.error("Error: ", error);
        })
    },
    shopNewsFetched(response) {
      this.shopNews = response.data.data;
      this.totalPages = response.data.totalPages
    },
    fetchShop() {
      this.$axios.get(`/shop/${this.route.params.shop}`, {
        params: {
          cityId: this.selectedArea.identifier,
        },
      })
        .then(this.shopFetched)
        .catch()
    },
    shopFetched(response) {
      this.shop = response.data.data;
      this.fetchShopNews();
    },
    getShortDay(day, language) {
      const days = {
        EN: {
          MONDAY: "Mo",
          TUESDAY: "Tu",
          WEDNESDAY: "We",
          THURSDAY: "Th",
          FRIDAY: "Fr",
          SATURDAY: "Sa",
          SUNDAY: "Su",
        },
        DE: {
          MONDAY: "Mo",
          TUESDAY: "Di",
          WEDNESDAY: "Mi",
          THURSDAY: "Do",
          FRIDAY: "Fr",
          SATURDAY: "Sa",
          SUNDAY: "So",
        },
      };
      // Convert the input day to uppercase to match the keys in the dictionary
      const uppercaseDay = day.toUpperCase();

      // Check if the language exists in the dictionary
      if (!days[language]) {
        throw new Error(`Unsupported language code: ${language}`);
      }

      // Check if the day exists in the selected language's dictionary
      const translatedDay = days[language][uppercaseDay];
      if (!translatedDay) {
        throw new Error(`Unsupported day: ${day} for language ${language}`);
      }

      return translatedDay;
    }
  },
};
</script>

<style scoped>
.inner-main {
  margin-left: auto;
  margin-right: auto;
  max-width: 1170px;
}

.description-wrapper {
  position: relative;
}

.description-text {
  display: block;
  max-height: 200px;
  /* Adjust the height based on your design */
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  transition: max-height 0.3s ease-in-out;
  font-size: 14px;
}

.description-text.truncated {
  max-height: 200px;
  /* Limit text height when truncated */
}

.description-text:not(.truncated) {
  max-height: none;
  /* Allow full text to show when toggled */
}

.text-link {
  text-decoration: none;
  color: #1e88e5;
  cursor: pointer;
  float: right;
}

.text-link:hover {
  text-decoration: underline;
}
</style>

<style>
/*.dialog-list-item {
  min-height: 30px !important;
  background-color: transparent !important;
}

*/

.v-chip.hoverable.v-chip--variant-flat {
  border: thin solid transparent !important;
}

.v-chip.hoverable .v-chip__content {
  cursor: pointer;
}



.share-hint,
.descrption-text {
  font-size: 14px !important;
}

h1 {
  font-size: 36px !important;
  ;
}

h4 {
  font-size: 16px !important;
  font-weight: 700;
}

.f-16 {
  font-size: 16px !important;
}

.edit-btn {
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 1;
}

.logo-sheet {
  background-image: url('https://d2v01xjmjw73dt.cloudfront.net/api/image/collection/6cc5fce5-d423-4af3-8bf8-e5d25a234e80/AVATAR');
  background-size: cover;
}
</style>
